export const isset = str => !!(str && str.trim().length);
